var _rect, _rect2, _rect3, _rect4, _circle, _path, _rect5, _rect6, _rect7, _rect8, _circle2, _path2, _g, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 256,
    viewBox: "0 0 240 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 193.012,
    width: 169.521,
    height: 62.8,
    rx: 13.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 94,
    y: 206.012,
    width: 94.95,
    height: 6.58322,
    rx: 3.29161,
    fill: "#1B3554"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 94,
    y: 218.012,
    width: 69.93,
    height: 6.58322,
    rx: 3.29161,
    fill: "#1B3554"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 94,
    y: 236.012,
    width: 27.1528,
    height: 6.58322,
    rx: 3.29161,
    fill: "#1B3554"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 222,
    r: 16,
    fill: "#BAC2CB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9394 228.048C64.2327 228.341 64.616 228.488 65 228.488C65.384 228.488 65.7672 228.341 66.0605 228.048L73.5607 220.548C74.1464 219.962 74.1464 219.013 73.5607 218.427C72.9749 217.841 72.0254 217.841 71.4396 218.427L65 224.866L61.5604 221.427C60.9746 220.841 60.0251 220.841 59.4393 221.427C58.8536 222.013 58.8536 222.962 59.4393 223.548L63.9394 228.048Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 120.014,
    width: 169.521,
    height: 62.8,
    rx: 13.5,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 94,
    y: 133.014,
    width: 94.95,
    height: 6.58322,
    rx: 3.29161,
    fill: "#1B3554"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 94,
    y: 145.014,
    width: 69.93,
    height: 6.58322,
    rx: 3.29161,
    fill: "#1B3554"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 94,
    y: 163.014,
    width: 27.1528,
    height: 6.58322,
    rx: 3.29161,
    fill: "#1B3554"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 149,
    r: 16,
    fill: "#BAC2CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9394 154.046C64.2327 154.34 64.616 154.486 65 154.486C65.384 154.486 65.7672 154.34 66.0605 154.046L73.5607 146.546C74.1464 145.96 74.1464 145.011 73.5607 144.425C72.9749 143.839 72.0254 143.839 71.4396 144.425L65 150.864L61.5604 147.425C60.9746 146.839 60.0251 146.839 59.4393 147.425C58.8536 148.011 58.8536 148.961 59.4393 149.546L63.9394 154.046Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2169_13679)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5 16.0971L191.021 36.1842C198.477 37.3252 204.521 42.5356 204.521 47.8138V83.0721C204.521 88.3504 198.477 93.5532 191.021 94.6848L50.5 109.601C43.0442 110.554 35 104.296 35 94.3982V31.2849C35 21.3875 42.0442 15.1364 49.5 16.0971Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2916 44.8812L185.658 51.0256C187.476 51.1583 188.95 52.4007 188.95 53.8002C188.95 55.1997 187.476 56.2647 185.658 56.179L97.2916 52.2136C95.4737 52.1361 94 50.4148 94 48.3687C94 46.3227 95.4737 44.7612 97.2916 44.8812Z",
    fill: "#1B3554"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2916 58.2468L160.638 59.7827C162.456 59.8284 163.93 61.1435 163.93 62.7201C163.93 64.2966 162.456 65.5748 160.638 65.5749L97.2916 65.5792C95.4737 65.5793 94 63.9207 94 61.8747C94 59.8286 95.4737 58.2043 97.2916 58.2468Z",
    fill: "#1B3554"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2916 78.2951L117.861 77.4477C119.679 77.3718 121.153 78.8246 121.153 80.6928C121.153 82.561 119.679 84.1725 117.861 84.2921L97.2916 85.6275C95.4737 85.744 94 84.1796 94 82.1336C94 80.0875 95.4737 78.3691 97.2916 78.2951Z",
    fill: "#1B3554"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 71.9971C74.8366 71.8237 82 64.8298 82 56.3777C82 47.9257 74.8366 40.6047 66 40.032C57.1634 39.4663 50 46.4656 50 55.6592C50 64.8527 57.1634 72.1683 66 71.9971Z",
    fill: "#008080"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.631 62.445C62.9653 62.8093 63.4022 62.9924 63.84 62.995C64.2778 62.9977 64.7147 62.8207 65.049 62.4628L73.5993 53.5072C74.2671 52.8238 74.2671 51.6839 73.5993 50.9566C72.9316 50.227 71.8491 50.1863 71.1813 50.8697L63.84 58.5356L59.9189 54.1969C59.2511 53.45 58.1686 53.4194 57.5008 54.1326C56.8331 54.8481 56.8331 56.0365 57.5008 56.7833L62.631 62.445Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2169_13679",
    x: 0,
    y: 0,
    width: 239.521,
    height: 163.697,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.226735 0 0 0 0 0.437054 0 0 0 0 0.687819 0 0 0 0.189057 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2169_13679"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2169_13679",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArt);
export default __webpack_public_path__ + "static/media/art.2c799dd086a4521ce978c8a4b2a38443.svg";
export { ForwardRef as ReactComponent };